export enum PalletCheckerRoutes {
    IDLE = "palletCheckerIdle",
    SIGNIN = "palletCheckerLogin",
    SETTINGS = "palletCheckerSettings",
}

export enum TestPalletCheckerRoutes {
    IDLE = "testPalletCheckerIdle",
    SIGNIN = "testPalletCheckerLogin",
    SETTINGS = "testPalletCheckerSettings",
}
